import { Label } from '@/components/ui/label';
import { PillTabsList } from '@/components/ui/pill-tabs-list';
import { Tabs } from '@/components/ui/tabs';
import { Textarea } from '@/components/ui/textarea';

const LENGTH_TABS = [
    { value: 'Brief', label: 'Brief' },
    { value: 'Standard', label: 'Standard' },
    { value: 'Extensive', label: 'Extensive' }
];

interface StepInstructionsProps {
    prompt: string;
    setPrompt: (v: string) => void;
    format: string;
    setFormat: (v: string) => void;
    depth: string;
    setDepth: (v: string) => void;
    length: string;
    setLength: (v: string) => void;
}

export function StepInstructions({
    prompt,
    setPrompt,
    format,
    setFormat,
    depth,
    setDepth,
    length,
    setLength
}: StepInstructionsProps) {
    return (
        <div className="space-y-6">
            <div>
                <h2 className="mb-0 font-medium text-2xl">Instructions</h2>
                <p className="text-muted-foreground text-base">
                    Define the agent's analytical focus and output style.
                </p>
            </div>

            <div className="space-y-4">
                <div className="flex flex-col gap-0.5">
                    <Label className="font-medium text-base">
                        Custom prompt
                    </Label>
                    <p className="text-muted-foreground text-sm">
                        Starting from a blank prompt, as a new job would.
                    </p>
                </div>
                <Textarea
                    value={prompt}
                    onChange={(e) => setPrompt(e.target.value)}
                    placeholder="Describe what this agent should analyse and report on…"
                    rows={16}
                    className="rounded-lg resize-y"
                />
            </div>

            <div className="flex flex-col gap-4">
                <Label className="w-32 font-medium text-base">
                    Output length
                </Label>
                <Tabs value={length} onValueChange={setLength}>
                    <PillTabsList tabs={LENGTH_TABS} />
                </Tabs>
            </div>

            {/* Output format / analysis depth — disabled for now, not yet
                wired into what the agent actually does.
            <div className="flex items-center gap-4 space-y-1.5">
                <Label className="w-32 font-semibold text-base">
                    Output format
                </Label>
                <SegmentedControl
                    options={['Article', 'Short brief', 'Dashboard digest']}
                    value={format}
                    onChange={setFormat}
                />
            </div>

            <div className="flex items-center gap-4 space-y-1.5">
                <Label className="w-32 font-semibold text-base">
                    Analysis depth
                </Label>
                <SegmentedControl
                    options={['Quick scan', 'Standard', 'Deep dive']}
                    value={depth}
                    onChange={setDepth}
                />
            </div>
            */}
        </div>
    );
}
